import React from 'react';
import { Container, Row, Col, ListGroup, ListGroupItem, Table } from 'reactstrap';
import Link from 'next/link';
// import { MdInfoOutline } from 'react-icons/md';
import { TiDeleteOutline } from 'react-icons/ti';
import Image from "next/legacy/image";

import { useCart } from 'shared/context/CartContext';
import formatMoney from 'shared/utils/formatMoney';
import SEO from 'shared/components/SEO';

function CartPage() {
  const { cart, addItem, removeItem, orderValue, shippingCost } = useCart();

  const checkoutButton = (
    <Link href="/checkout" className="btn btn-success">
      Afrekenen
    </Link>
  );

  return (
    <Container className="py-3">
      <SEO
        title="Winkelmandje"
        description="Bekijk hier al de items in jouw winkelmandje"
        canonical="/cart"
      />
      <div id="cartPage">
        <div className="mb-4 d-flex justify-content-between align-items-center flex-wrap">
          <h1>Winkelmandje</h1>
          {cart.length > 0 && checkoutButton}
        </div>

        {cart.length > 0 ? (
          <>
            <ListGroup>
              {cart.map((item, index) => (
                <ListGroupItem key={`cartItem${index}-${item._id}`} className="cartItem">
                  <Row>
                    <Col md="3" lg="2">
                      <div style={{ width: 200, maxWidth: '100%' }} className="mx-auto">
                        <Image
                          className="p-4 mx-auto d-block"
                          src={item.image.src.small}
                          alt={item.name}
                          width={400}
                          height={400}
                        />
                      </div>
                    </Col>
                    <Col md="9" lg="10">
                      <Row className="mb-2">
                        <Col xs="12" className="mb-3">
                          <Link
                            href="/[categoryName]/[slug]"
                            as={`/${item.category}/${item.slug}`}
                            className="text-dark">

                            <h3>{item.name}</h3>

                          </Link>
                          <span>{formatMoney(item.pricing.sellingPrice)} / stuk</span>{' '}
                          {item.inventory && item.inventory.moq && item.inventory.moq > 1 && (
                            <span>( Per {item.inventory.moq} te bestellen)</span>
                          )}
                        </Col>
                        <Col xs="8" className="d-flex align-items-center">
                          <div className="d-flex justify-content-between align-items-center">
                            {/* <Button color="white" onClick={() => removeItem(item)}>
                              verwijderen
                            </Button> */}
                            <ListGroup horizontal>
                              <ListGroupItem
                                tag="button"
                                className="btn btn-sm btn-outline-success px-3 py-1"
                                onClick={() => removeItem(item, item.inventory.moq || 1)}
                              >
                                -
                              </ListGroupItem>
                              <ListGroupItem
                                tag="div"
                                className="px-3 py-1"
                              >{`${item.quantity}`}</ListGroupItem>
                              <ListGroupItem
                                tag="button"
                                className="btn btn-sm btn-outline-success px-3 py-1"
                                onClick={() => addItem(item, item.inventory.moq)}
                                disabled={
                                  (item.inventory.stock / item.inventory.moq || 1) <= item.quantity
                                }
                              >
                                +
                              </ListGroupItem>
                              <ListGroupItem
                                tag="button"
                                className="btn btn-sm btn-outline-light px-3 py-1 ms-2 border-0"
                                onClick={() => removeItem(item)}
                              >
                                <TiDeleteOutline color="red" />
                              </ListGroupItem>
                            </ListGroup>
                          </div>
                        </Col>
                        <Col xs="4" className="d-flex align-items-center justify-content-end">
                          <span>{formatMoney(item.quantity * item.pricing.sellingPrice)}</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </ListGroupItem>
              ))}
            </ListGroup>

            <Row>
              <Col md={{ size: 6, offset: 6 }}>
                <Table className="mt-4">
                  <tbody>
                    <>
                      {/* <tr>
                        <th>Leverkosten</th>
                        <td className="text-end">{formatMoney(shippingCost)}</td>
                      </tr> */}
                      {/* <tr
                        rowSpan="2"
                        className="px-2 mb-1 text-muted d-flex align-items-center font-weight-light"
                        style={{ fontSize: 14 }}
                      >
                        <div>
                          <MdInfoOutline className="me-2 text-success" />
                          Gratis verzending vanaf € 250,00
                        </div>
                      </tr> */}
                    </>

                    <tr>
                      <th>Totaal</th>

                      <td className="text-end">{formatMoney(orderValue)}</td>
                    </tr>
                  </tbody>
                </Table>
                <div className="d-flex justify-content-end">{checkoutButton}</div>
              </Col>
            </Row>
          </>
        ) : (
          <p>Je hebt nog geen producten in je winkelmandje</p>
        )}
      </div>
    </Container>
  );
}

export default CartPage;
